import "./Login.css";
import { FiLock } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IoArrowBack } from "react-icons/io5";
import Spinner from "../Loading/Spinner";
import { RxCross2 } from "react-icons/rx";
import React, { useEffect, useState } from "react";
import { UserLogin } from "../../redux/actions/User";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { Loading } from "notiflix/build/notiflix-loading-aio";
import ClerkSignInButton from "../../auth/ClerkSignInButton";
import { CLERK_PUBLISHABLE_KEY } from "../../auth/clerkConfig";



const Loginbox = ({ isModalLogin = false, setModalShow, setActive }) => {

  const isLoading = useSelector((state) => state.user.isLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);


  const dataSubmit = (e) => {
    e.preventDefault();
    dispatch(UserLogin(email, password, navigate, isModalLogin, setModalShow));
  };

  // loading statement
  useEffect(() => {
    if (isLoading === true) {
      Loading.standard("Loading Please Wait", {
        svgColor: "#CD292E",
      });
    } else {
      Loading.remove();
    }
  }, [isLoading]);


  const handelNavigate = () => {
    if (isModalLogin) {
      setActive(2)
    } else {
      navigate('/registration' + window.location.search);
    }
  }

  const handleGoogleLogin = () => {
    // Google login functionality to be implemented
    console.log("Google login clicked");
  }

  const handleGithubLogin = () => {
    // GitHub login functionality to be implemented
    console.log("GitHub login clicked");
  }


  return (
    <div className="login-box">
      {
        isModalLogin ? (
          <RxCross2
            onClick={() => setModalShow(false)}
            className="text-[23px] float-right hover:text-[#CD292E] cursor-pointer"
          />
        ) : (
          <NavLink to="/" className="back-to-home">
            <IoArrowBack />
            <span>Back to Home</span>
          </NavLink>
        )
      }
      
      {/* Logo */}
      <div className="login-logo">
        <span className="logo-insta">INSTA</span>
        <span className="logo-pass">PASS</span>
      </div>
      
      {/* Welcome Text */}
      <h2 className="welcome-title">Welcome Back</h2>
      <p className="welcome-subtitle">Sign in to access your organizer portal</p>
      
      <form onSubmit={dataSubmit}>
        {/* Email Field */}
        <div className="input-group">
          <label className="input-label">Email Address</label>
          <div className="input-wrapper">
            <MdOutlineEmail className="input-icon" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setemail(e.target.value)}
              placeholder="your@email.com"
              className="login-input"
            />
          </div>
        </div>

        {/* Password Field */}
        <div className="input-group">
          <label className="input-label">Password</label>
          <div className="input-wrapper">
            <FiLock className="input-icon" />
            <input
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              type={showPassword ? "text" : "password"}
              required
              placeholder="Enter your password"
              className="login-input"
            />
            <button 
              type="button" 
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {/* Remember Me & Forgot Password */}
        <div className="login-options">
          {/* <label className="remember-me">
            <input 
              type="checkbox" 
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <span>Remember me</span>
          </label> */}
          <NavLink to="/forgotpassword" className="forgot-password">
            Forgot password?
          </NavLink>
        </div>

        {/* Sign In Button */}
        <button
          type="submit"
          className={`signin-btn ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
          disabled={isLoading}
        >
          {isLoading ? <Spinner /> : "Sign In"}
        </button>

        {/* Divider */}
        <div className="divider">
          <span>or</span>
        </div>

        {/* Sign in with Apple, Google or a phone code (Clerk) — same as the InstaPass app */}
        {CLERK_PUBLISHABLE_KEY && <ClerkSignInButton onOpen={() => isModalLogin && setModalShow?.(false)} />}

        {/* Social Login Buttons */}
        {/* <button type="button" className="social-btn google-btn" onClick={handleGoogleLogin}>
          <svg className="google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span>Continue with Google</span>
        </button> */}

        {/* <button type="button" className="social-btn github-btn" onClick={handleGithubLogin}>
          <svg className="github-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
          <span>Continue with GitHub</span>
        </button> */}

        {/* Sign Up Link */}
        <p className="signup-link">
          Don't have an account? <span onClick={handelNavigate}>Sign up</span>
        </p>
      </form>
    </div>
  )
}

export default Loginbox
